module.exports = __webpack_public_path__ + "static/media/stop-16.3b921112.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/stop-markers/stop-16.svg
// module id = 1361
// module chunks = 0